import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { from } from 'rxjs'
import { map, switchMap, tap } from 'rxjs/operators'
import { PackageTypesService } from 'src/services/data/package-types.service'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { createPackageType, createPackageTypeFailure, createPackageTypeSuccess, deletePackageType, deletePackageTypeFailure, deletePackageTypeSuccess, loadPackageTypes, loadPackageTypesFailure, loadPackageTypesSuccess, updatePackageType, updatePackageTypeFailure, updatePackageTypeSuccess } from './package-type.actions'

@Injectable()
export class PackageTypeEffects {
  private actions$ = inject(Actions)
  private PackageTypes = inject(PackageTypesService)
  private toaster = inject(ToasterService)


  loadPackageTypes$ = createEffect(() => this.actions$.pipe(
    ofType(loadPackageTypes),
    switchMap(() =>
      from(this.PackageTypes.getPackageTypes()).pipe(
        map(packageTypes => loadPackageTypesSuccess({ packageTypes })),
        catchAndLog(this.toaster, 'Unable to fetch packageTypes', loadPackageTypesFailure)))))

  createPackageType$ = createEffect(() => this.actions$.pipe(
    ofType(createPackageType),
    tap(() => this.toaster.progress('Creating package type...')),
    switchMap(action =>
      from(this.PackageTypes.create(action.packageType)).pipe(
        map(packageType => createPackageTypeSuccess({ packageType })),
        tap(() => this.toaster.success('Package type created successfully.')),
        catchAndLog(this.toaster, 'Unable to create package type', createPackageTypeFailure)))))

  updatePackageType$ = createEffect(() => this.actions$.pipe(
    ofType(updatePackageType),
    tap(() => this.toaster.progress('Updating package type...')),
    switchMap(action =>
      from(this.PackageTypes.update({ ...action.packageType, package_id: action.id })).pipe(
        map(packageType => updatePackageTypeSuccess({ packageType })),
        tap(() => this.toaster.success('Package type updated successfully.')),
        catchAndLog(this.toaster, 'Unable to update package type', updatePackageTypeFailure)))))

  deletePackageType$ = createEffect(() => this.actions$.pipe(
    ofType(deletePackageType),
    tap(() => this.toaster.progress('Deleting package type...')),
    switchMap(action =>
      from(this.PackageTypes.remove(action.id)).pipe(
        map(() => deletePackageTypeSuccess({ id: action.id })),
        tap(() => this.toaster.success('Package type deleted successfully.')),
        catchAndLog(this.toaster, 'Unable to delete package type', deletePackageTypeFailure)))))
}
